export function parseInstagramUsername(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;

  if (/instagram\.com/i.test(trimmed)) return null;
  if (/^https?:\/\//i.test(trimmed)) return null;
  if (/\s/.test(trimmed)) return null;

  const username = trimmed.replace(/^@+/, "");
  if (!username) return null;
  if (!/^[a-zA-Z0-9._]{1,30}$/.test(username)) return null;
  if (/^\./.test(username) || /\.$/.test(username)) return null;
  if (/\.\./.test(username)) return null;

  return username;
}
